<script>
    import R, {LOADER} from "../lib/requests";
    import Modal from '../components/modal/Modal.svelte';
    import {setFocusTo, trim, isCorrectMobile} from "../lib/lib";
    import Notifier from "../stores/notifier";

    export let mobile;
    export let notification_type;
    export let onClose = () => {
    };

    const send = () => {

        const onSuccess = result => {
            Notifier.showMessage("Test notification sent successfully");
        }

        const onFailure = err => {
            Notifier.showError("Test notification failed");
        };

        mobile = trim(mobile);
        if (mobile) {
            // remove spaces, +, - r anything else
            mobile = mobile.replace(/\D/g, '');
        }

        if (!isCorrectMobile(mobile)) {
            Notifier.showError("Mobile number is not correct!");
            setFocusTo("testMobile");
            return;
        }

        R.handle(R.app.testNotification, {notification_type, mobile}, onSuccess, onFailure, LOADER.POPUP);
    }

    if (notification_type == 0) {
        notification_type = 1;
    }

    setFocusTo('testMobile');
</script>

<Modal title="Test notification" on:close={onClose}>
    <div slot="body">
        <p>
            Send test notification to
        </p>
        <div class="form-group">
            <label>Mobile</label>
            <input type="text" class="form-control" id="testMobile" bind:value={mobile}>
        </div>
        <div class="form-group">
            <select class="form-select" bind:value={notification_type}>
                <option value={1}>Test with SMS</option>
                <option value={2}>Test with WhatsApp</option>
            </select>
        </div>
        <hr>
        <div class="text-end">
            <button class="btn btn-link me-2" on:click={onClose}>Close</button>
            <button class="btn btn-primary px-4" on:click={send}>Send</button>
        </div>
    </div>
</Modal>